import { v4 as uuid } from 'uuid';

import { AddNotification, AddToastNotification } from '@/constants/mutations';
import { notifications } from '@/constants/notifications';

const DEFAULT_TOAST_CONFIG = {
  type: 'info',
  duration: '4000',
  closable: false,
  opened: false,
};

export class NotificationService {
  constructor(ctx) {
    const { store } = ctx;
    this.store = store;
  }

  /**
   * Show a toast notification.
   */
  toast(event) {
    const { name, ...data } = event;
    const toastConfig = name ? notifications[name](data) : data;
    const notification = { id: uuid(), ...DEFAULT_TOAST_CONFIG, ...toastConfig };

    this.store.dispatch(`notificationStore/${AddToastNotification}`, notification);

    return notification.id;
  }

  /**
   * Show a bell notification.
   */
  bell(event) {
    this.store.commit(`notificationStore/${AddNotification}`, event);
  }
}
